import type { FastifyInstance } from "fastify";

export const allWhatsAppMessages = async (
  app: FastifyInstance,
  limit: number,
  page: number,
) => {
  try {
    const messages = await app.prisma.message.findMany({
      select: {
        id: true,
        content: true,
        status: true,
        createdAt: true,
        customer: {
          select: {
            name: true,
            phone: true,
          },
        },
      },
      orderBy: {
        createdAt: "desc",
      },
      take: limit,
      skip: page && limit ? (page - 1) * limit : 0,
    });
    const totalMessages = await app.prisma.message.count();
    return {
      status: "success",
      data: messages,
      meta: {
        total: totalMessages,
        page,
        limit,
        totalPages: Math.ceil(totalMessages / limit),
      },
    };
  } catch (error: any) {
    app.log.error("Error fetching WhatsApp messages:", error);
    return {
      status: "error",
      message: "Failed to fetch WhatsApp messages",
    };
  }
};

export const queueWhatsAppMessage = async (
  app: FastifyInstance,
  phone: string,
  content: string,
) => {
  let customer = await app.prisma.customer.findUnique({
    where: { phone },
  });

  if (!customer) {
    customer = await app.prisma.customer.create({
      data: {
        phone,
        name: "Unknown",
      },
    });
  }

  const message = await app.prisma.message.create({
    data: {
      content,
      customerId: customer.id,
      status: "pending",
    },
  });

  await app.whatsappQueue.add("send-whatsapp", {
    to: phone,
    message: content,
    messageId: message.id,
  });

  return message;
};
